import ImageStorage from "../utils/ImageStorage";

const SideBar = () => {
  return (
    <>
      <div className="sidebar">
        <img
          className="sidebar-background"
          src={ImageStorage.FloatingBackground}
        />
        <div className="sidebar-wrapper">
          <div className="sidebar-qr">
            <img src={ImageStorage.QrCode} alt="QR Code" />
          </div>
          <a
            className="sidebar-button-recharge"
            href="https://pay.zing.vn/zalo/products/vlg"
            rel="noreferrer"
            target="_blank"
          >
            <img src={ImageStorage.FloatingTopup} alt="Nạp thẻ" />
          </a>
          <a
            className="sidebar-button-download"
            href="https://play.google.com/store/apps/details?id=zagoo.game.vlg"
            rel="noreferrer"
            target="_blank"
          >
            <img src={ImageStorage.FloatingGGPlay} alt="Google Play" />
          </a>
          <a
            className="sidebar-button-download"
            href="https://h5.zadn.vn/games/vlg/Packages/zagoo.game.vlg-release-v1.0-12-2023-02-13.apk"
            rel="noreferrer"
            target="_blank"
          >
            <img src={ImageStorage.FloatingAPK} alt="Tải xuống APK" />
          </a>
          <div className="flex justify-center">
            <a
              className="sidebar-button-social"
              href="https://zalo.me/talavuonglaogiazagoo"
              target="_blank"
              rel="noreferrer"
            >
              <img src={ImageStorage.ButtonZalo} alt="Zalo" />
            </a>
            <a
              className="sidebar-button-social"
              href="https://www.facebook.com/vuonglaogia.zagoo.vn/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={ImageStorage.ButtonFacebook} alt="Facebook" />
            </a>
          </div>
          <a
            className="sidebar-button-play"
            href="/play-game?utm_source=Website&utm_medium=Homepage-tlvlg&utm_campaign=BR-PN-0000-MF-AR-280522-1000-KP-TQ-BN-ZG-RTS752-button-choingay"
            target="_blank"
            rel="noreferrer"
          >
            <img src={ImageStorage.ButtonPlaySidebar} alt="Play" />
          </a>
        </div>
      </div>
    </>
  );
};

export default SideBar;
